import { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { AUDIENCES } from "@/data/content";

export default function IdealFor() {
  const [active, setActive] = useState(AUDIENCES[0].key);
  const current = AUDIENCES.find((a) => a.key === active) || AUDIENCES[0];

  return (
    <section id="ideal-fuer" className="section-pad bg-white" data-testid="section-ideal-fuer">
      <div className="container-x">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm font-bold tracking-wide text-[color:var(--brand-green-alt)] uppercase">Ideal für</span>
          <h2 className="mt-2 font-display text-4xl sm:text-5xl text-[color:var(--brand-navy)]">Für wen ist der Hausnotruf gedacht?</h2>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-2.5" role="tablist" aria-label="Zielgruppen" data-testid="ideal-fuer-tabs">
          {AUDIENCES.map((a) => (
            <button
              key={a.key}
              role="tab"
              aria-selected={active === a.key}
              onClick={() => setActive(a.key)}
              data-testid={`ideal-tab-${a.key}`}
              className={`px-5 py-2.5 rounded-full text-sm font-bold transition-colors border ${active === a.key ? "bg-[color:var(--brand-navy)] text-white border-[color:var(--brand-navy)]" : "bg-white text-[color:var(--brand-navy)] border-border hover:bg-secondary"}`}
            >
              {a.label}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center rounded-3xl border border-border bg-secondary p-5 sm:p-8">
          <div className="order-2 lg:order-1">
            <h3 className="text-2xl sm:text-3xl font-bold text-[color:var(--brand-navy)]">{current.title}</h3>
            <p className="mt-3 text-base sm:text-lg text-muted-foreground leading-relaxed">{current.text}</p>
            <ul className="mt-5 space-y-3">
              {current.points.map((p) => (
                <li key={p} className="flex items-start gap-3 text-[15px] font-medium text-[color:var(--brand-navy)]">
                  <CheckCircle2 className="h-5 w-5 mt-0.5 text-[color:var(--brand-green-alt)] shrink-0" /> {p}
                </li>
              ))}
            </ul>
          </div>
          <div className="order-1 lg:order-2">
            <img
              src={current.img}
              alt={current.title}
              loading="lazy"
              className="w-full h-64 sm:h-80 object-cover rounded-2xl card-shadow"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
